import { render, staticRenderFns } from "./uploadEvidence.vue?vue&type=template&id=6a54a828&scoped=true&"
import script from "./uploadEvidence.vue?vue&type=script&lang=js&"
export * from "./uploadEvidence.vue?vue&type=script&lang=js&"
import style0 from "./uploadEvidence.vue?vue&type=style&index=0&id=6a54a828&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a54a828",
  null
  
)

export default component.exports